module.exports = __webpack_public_path__ + "img/country_white_grey_ba_list.660fc300.jpg";